<div class="d-flex justify-content-end px-3 pt-2" *ngIf="showRefreshVacuumValues">
  <button mat-flat-button color="warn" [disabled]="!canRefreshVacuumValues" (click)="refreshVacuumValues()">
    <mat-icon>update</mat-icon>&nbsp;Refresh Vacuum Values
  </button>
</div>
<div *ngFor="let group of groups" class="py-1">
  <div class="px-3 pt-2 pb-1 d-flex align-items-center gap-1">
    <mat-icon class="blue" style="font-size: 18px; width: 18px; height: 18px"
      >speed</mat-icon
    >
    <span [innerHTML]="groupLabel(group)"></span>
  </div>
  <div *ngFor="let vacuum of group.vacuums" class="py-1">
    <cl-checkbox-and-text-input
      [number]="vacuum.index.toString()"
      [textBefore]="vacuumTextBefore(vacuum)"
      [textAfter]="vacuumTextAfter(vacuum)"
      [textValue]="vacuum.textValue ?? vacuumPlaceholder(vacuum)"
      [checked]="vacuum.checked"
      [disabled]="vacuumDisabled(vacuum)"
      [disableEdit]="!!(editor || builder || vacuum.checked)"
      [color]="color"
      [roleIds]="roleIds"
      [roleCodes]="roleCodes"
      [user]="vacuum.user"
      [date]="vacuum.date"
      [warning]="isExecutionMode && !vacuum.isValid"
      [moreInfo]="vacuumRequirement(vacuum)"
      (answered)="checkboxChanged(vacuum, $event)"
      (changed)="textChanged(vacuum, $event)"
    ></cl-checkbox-and-text-input>
  </div>
</div>
